import { Event } from '../Event'
import { ViewerContext } from '../../constants'
import { SellableProperties } from './types'

export interface ProductRemovedEventProperties extends SellableProperties {}

export class ProductRemovedEvent extends Event<ProductRemovedEventProperties> {
  static displayName = 'Product Removed'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
